import Clarity from '@microsoft/clarity';
import { useEffect } from 'react';

import config from '../config';

export const useClaritySession = () => {
  useEffect(() => {
    if (import.meta.env.PROD) {
      Clarity.init(config.clarityProjectId);
      Clarity.consent();
    }
  }, []);
};
